import React, { useEffect, useState } from 'react';
import { MessageSquare } from 'lucide-react';
export function ChatWidget() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show the fixed widget after scrolling past the hero (approx 400px)
      setIsScrolled(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check initial position
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <button className={`fixed bottom-6 right-4 sm:right-6 z-50 flex items-center sm:gap-3 bg-navy text-white p-3 sm:px-4 sm:py-3 rounded-full shadow-2xl hover:bg-navy/90 hover:scale-105 transition-all group border border-white/10 ${isScrolled ? 'opacity-100 translate-y-0' : 'lg:opacity-0 lg:translate-y-10 lg:pointer-events-none'}`} aria-label="Open quick answer chat" data-id="element-46">
      <div className="flex flex-col items-start pr-2 hidden sm:flex" data-id="element-47">
        <span className="text-sm font-bold leading-none" data-id="element-48">
          Need a Quick Answer?
        </span>
        <span className="text-[10px] text-off-white/70 uppercase tracking-wider mt-1" data-id="element-49">
          Ask FSG
        </span>
      </div>
      <div className="bg-red w-12 h-12 sm:w-10 sm:h-10 rounded-full flex items-center justify-center shrink-0 shadow-inner" data-id="element-50">
        <MessageSquare className="w-6 h-6 sm:w-5 sm:h-5 text-white" data-id="element-51" />
      </div>
    </button>;
}